import { STORE_FOOD_AND_REC_URLS, CLEAR_FOOD_AND_REC_URLS } from "../actions";

function saveFoodNRecURLS(payload) {
  return {
    type: STORE_FOOD_AND_REC_URLS,
    payload
  };
}

function clearFoodNRecURLS(payload) {
  return {
    type: CLEAR_FOOD_AND_REC_URLS,
    payload
  };
}

export { saveFoodNRecURLS, clearFoodNRecURLS };



// WEBPACK FOOTER //
// ./src/store/actionCreators/saveFoodNRecURLS.js